import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { CareRecordButtonGroup } from '../mui/radio/Radio';
import { color } from '../../styles';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

const InnerRowContainer = css`
  height: 72px;
`;

const LabelContainer = css`
  display: flex;
  flex-direction: column;
  width: 60px;
  margin: 0 8px 0 0;
`;

const TableIcon = css`
  width: 30px;
  min-width: 30px;
  height: 30px;
  margin: 4px;
`;

const TableLabel = css`
  font-size: 14px;
  color: ${color.dark_gray};
  line-height: 1em;
  flex-shrink: 0;
`;

export const CareRecordPadUrineVolumeTypeSection = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={[AlignCenter, InnerRowContainer]}>
      <div css={[LabelContainer, AlignCenter]}>
        <img css={TableIcon} src='/images/residents/recordModal/pad.svg' alt='' />
        <div css={TableLabel}>
          <span>
            {t('diaper', 'おむつ')}
            <br />
            {t('pad', 'パッド')}
          </span>
        </div>
      </div>
      <CareRecordButtonGroup
        data={[
          { key: 'large', value: t('large', '多'), icon: '/images/recordButtonIcon/urine-large.svg' },
          { key: 'medium', value: t('medium', '中'), icon: '/images/recordButtonIcon/urine-medium.svg' },
          { key: 'small', value: t('small', '少'), icon: '/images/recordButtonIcon/urine-small.svg' },
          { key: 'none', value: t('none', '無'), icon: '/images/recordButtonIcon/urine-none.svg' },
        ]}
        newValue={form.padUrineVolumeType}
        onChange={form.handleChangePadUrineVolumeType}
      />
    </div>
  );
};
